/**
 * Shared constants and helpers for the PageContainersList drag-and-drop tree.
 */

import { ContainerAPI } from '../../types/state.types';
import { CONTAINER_CONSTRAINTS } from '../../container-management/constants/constraints';

/** Deepest level that may still contain nested containers (0-indexed depth). */
export const DEEPEST_PARENT_LEVEL = CONTAINER_CONSTRAINTS.MAX_NESTING_DEPTH - 2; // 1

/** Prefix used on the top-level Droppable id so we can distinguish it from
 *  a nested container's droppableId (which is the container's own id). */
export const ROOT_DROPPABLE_PREFIX = 'root::';

/**
 * Sort siblings the same way the canvas displays them: rowIndex first,
 * then order within a row. Mirrors getContainerRows in
 * container-management/utils/rowCalculations.ts.
 */
export const sortByRowThenOrder = (a: ContainerAPI, b: ContainerAPI) => {
  const rowDiff = (a.rowIndex ?? 0) - (b.rowIndex ?? 0);
  return rowDiff !== 0 ? rowDiff : a.order - b.order;
};
